export type ConsentGroup = 'C0001' | 'C0002' | 'C0003' | 'C0004';

export type HasConsentGroupParams = {
    group: ConsentGroup;
    groups?: string | string[];
};

export function hasConsentGroup({ group, groups }: HasConsentGroupParams): boolean {
    if (Array.isArray(groups)) {
        return groups.includes(group);
    }

    if (typeof groups === 'string') {
        return groups.includes(`,${group},`);
    }

    return false;
}
